module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('modal', {
    staticClass: "confirmation-modal",
    attrs: {
      "id": "confirmationModal",
      "width": "502px",
      "value": _vm.showModal,
      "effect": "fade",
      "large": ""
    },
    on: {
      "closed": _vm.closed
    }
  }, [_c('div', {
    staticClass: "modal-header",
    attrs: {
      "slot": "modal-header"
    },
    slot: "modal-header"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_c('strong', [_vm._v("管理番号'" + _vm._s(_vm.linkNumber) + "'を割り当てます。割り当てるライセンス数を入力してください。")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body confirmation-modal-body ",
    style: ('Width: 201px;padding: 5px 15px; ')
  }, [(_vm.maxQty) ? _c('span', {
    staticStyle: {
      "float": "right",
      "font-weight": "800"
    }
  }, [_vm._v("ライセンス残数: " + _vm._s(_vm.maxQty))]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "float": "right",
      "font-weight": "800",
      "padding": "7px"
    }
  }, [_vm._v("本")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedValue),
      expression: "selectedValue"
    }],
    staticClass: "form-control",
    staticStyle: {
      "width": "60px",
      "float": "right"
    },
    attrs: {
      "type": "number",
      "min": "1",
      "max": _vm.maxQty
    },
    domProps: {
      "value": (_vm.selectedValue)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.selectedValue = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "float": "right",
      "font-weight": "800",
      "padding": "7px"
    }
  }, [_vm._v("割り当てるライセンス数：")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("※割り当てるライセンス数はライセンス残数以下の数量しか指定できません")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer",
    staticStyle: {
      "background": "white"
    },
    attrs: {
      "slot": "modal-footer"
    },
    slot: "modal-footer"
  }, [_c('button', {
    class: 'btn btn-default ',
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.closed('no')
      }
    }
  }, [_vm._v("戻る")]), _vm._v(" "), _c('button', {
    class: 'confirmation-modal-footer-yes-btn btn btn-primary',
    attrs: {
      "type": "button",
      "id": "confirmationModalYes"
    },
    on: {
      "click": _vm.confirmOK
    }
  }, [_vm._v("OK")])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1b6368bc","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modals/confirmation-modal-device-link.vue
// module id = 939
// module chunks = 0